import React from 'react';
import firebase,{ db } from '../../config/firebase';
// material ui
import CircularProgress from '@mui/material/CircularProgress';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import { Dialog, DialogActions, DialogContent, DialogTitle, Snackbar, Backdrop } from "@mui/material";
import { AddCircle } from '@mui/icons-material';
// components
import Input from '../custom-comp/Input';
import { childDialogTheme } from '../../config/theme';
import '../../assets/stylesheet/addcompany.css';

const ColorCircularProgress = withStyles({
    root: {
      color: '#0F467A',
      width:'20px !important',
      height:'20px !important',
      position:'absolute'
    },
})(CircularProgress);

const styles = theme => ({
    saveBtn:{
        width:'64px',
        height:'40px',
        backgroundColor:'#0F467A',
        border:'1px solid #707070',
        borderRadius:'5px',
        textAlign:'center',
        color:'#fff',
        textTransform:'uppercase',
        fontSize:'13px',
        lineHeight:3,
        cursor:'pointer',
        fontWeight:'bold',
        fontFamily: "'Poppins', sans-serif",
        display:'flex',
        flexDirection:'column',
        justifyContent:'center',
        alignItems:'center'
    },

    dialogRoot:{
        backgroundColor: '#0F467A',
        textAlign: 'center',
        fontFamily: "'Poppins', sans-serif"
    },

    photoDiv:{
        alignSelf: 'center',
        position: 'relative',
        border: '1px solid #C4C4C4',
        width: '100px',
        height: '100px',
        borderRadius: '50px',
        margin: '10px 0px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        cursor: 'pointer',
        "& span":{
            textTransform: 'capitalize',
            textAlign: 'center',
            color: '#0F467A',
            fontFamily: "'Poppins', sans-serif",
        },
        "& img":{
            width: '100%',
            height: '100%',
            borderRadius: '50px'
        },
        [theme.breakpoints.between('xs','md')]: {
            width: '80px',
            height: '80px',
        }
    },

    photoIcon:{
        position: 'absolute',
        bottom: '0px',
        right: '0px',
        color: '#0F467A',
    },

    input:{
        display: 'block',
        padding: '10px 14px',
        fontFamily: "'Poppins', sans-serif",
        fontSize: '1em',
        outline: 0,
        borderRadius: '4px',
        backgroundColor: '#F4F6F8',
        border:'1px solid #E5E5E5',
        [theme.breakpoints.between('xs','md')]: {
            padding: '10px 5px',
		}
    },

    contentRoot:{
        display:'flex',
        flexDirection:'column',
        [theme.breakpoints.between('xs','md')]: {
            padding:'8px 9px'
		}
    },

    inputDiv:{
        display:'flex',
        flexDirection:'column',
        width:'220px',
        margin: '10px 0 20px 0',
        [theme.breakpoints.between('xs','md')]: {
            width:'46%',
		}
    },

    labelSpan:{
        fontSize:'15px',
        textTransform:'capitalize',
        color:'#0F467A',
        [theme.breakpoints.between('xs','md')]: {
            fontSize:'11px',
		}
    },

    cancelBtn:{
        color:'#000',
        backgroundColor:'#e3e4e6',
        borderColor:'#e3e4e6'
    },

    marLeft:{
        marginLeft:'10px'
    },

    backdrop: {
        zIndex: 111125,
        color: '#fff',
    },
})

class ChildDialog extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            avatarUrl:'',
            avatar:'',
            firstName:'',
            lastName:'',
            gender:'',
            birthdate:'',
            loading:false,
            saveClick:true,
            kidData:{},
            isEdit:false
        }
        this.fileUploader = React.createRef();
    }

    componentDidMount() {
        this._isMounted = true;
        const { kidId } = this.props;
        if(kidId) {
            db.ref(`Kids/${kidId}`).once('value',(data)=> {
                let resData = data.val();
                if(resData && this._isMounted) {
                    resData.birthdate = this.formatDate(resData.birthdate*1000);
                    this.setState({kidData:resData,isEdit:true})
                }
                else{
                    this.setState({message:'No Kid Found',open:true},() => {
                        setTimeout(()=> this.handleClose2(),1500);
                    })
                }
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        this._isMounted = true;
        if (prevProps.kidId !== this.props.kidId) {
            if(this._isMounted) this.setState({kidData:{},isEdit:false})
            db.ref(`Kids/${this.props.kidId}`).once('value',(data)=> {
                let resData = data.val();
                if(resData && this._isMounted) {
                    resData.birthdate = this.formatDate(resData.birthdate*1000);
                    this.setState({kidData:resData,isEdit:true})
                }
                else{
                    this.setState({message:'No Kid Found',open:true},() => {
                        setTimeout(()=> this.handleClose2(),1500);
                    })
                }
            })
        }
    }

    formatDate = (date) => { // convert timestamp to date format
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
    
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
    
        return [year, month, day].join('-');
    }

    generateId = () => { // generate random id for avatar to avoid overwrite in storage
        var result = '';
        var length = 15;
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
           result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    // set state on close dialog
    resetState = () => {
        this._isMounted = true;
        if(this._isMounted) {
            this.setState({
                avatarUrl:'',
                avatar:'',
                firstName:'',
                lastName:'',
                gender:'',
                birthdate:'',
                saveClick:true,
                kidData:{},
                isEdit:false
            })
        }
    }

    // add new kid to db
    addNewKid = () => {
        let {firstName,lastName,avatar,gender,birthdate,saveClick} = this.state;
        let {parentId,onSaveChild,t} = this.props;
        if(saveClick) {
            if(!parentId) {
                this.setState({message:t('booking.dialog.validation.parentId'),open:true})
            }
            else if(!firstName) {
                this.setState({message:t('booking.dialog.validation.fName'),open:true})
            }
            else if(!lastName) {
                this.setState({message:t('booking.dialog.validation.lName'),open:true})
            }
            else if(!birthdate) {
                this.setState({message:t('booking.dialog.validation.birthdate'),open:true})
            }
            else if(!gender) {
                this.setState({message:t('booking.dialog.validation.gender'),open:true})
            }
            else{
                this.setState({saveClick:false,loading:true});
                birthdate = Math.floor(new Date(birthdate).getTime() / 1000);
                let kidRef = db.ref('Kids/').push();
                let kidObject = {firstName,lastName,birthdate,gender,parentId,'id':kidRef.key};
                if(avatar) {
                    let randomId = this.generateId(); // generate random name for avatar to avoid overwrite
                    let storageRef = firebase.storage().ref().child(`Avatars/${randomId}`)
                    storageRef.put(avatar)
                    .then((url) =>{
                        url.ref.getDownloadURL()
                        .then((res) =>{ 
                            kidObject.avatar = res
                            kidRef.set(kidObject).then(()=> {
                                this.setState({loading:false},()=> {
                                    onSaveChild();
                                    this.resetState();
                                })
                            }).
                            catch(e => {
                                this.setState({message:e.message,open:true,loading:false})     
                                console.log('e',e)
                            })
                        }).catch(e => {
                            this.setState({message:e.message,open:true,loading:false})     
                            console.log('e',e)
                        })
                    })
                    .catch(e => {
                        this.setState({message:e.message,open:true,loading:false})
                        console.log('e',e)
                    })
                }
                else{
                    kidRef.set(kidObject).then(async()=> {
                        setTimeout(()=> this.setState({loading:false},()=> onSaveChild()),1000);
                        setTimeout(()=> this.resetState(),2000);
                    }).
                    catch(e => {
                        this.setState({message:e.message,open:true,loading:false})     
                        console.log('e',e)
                    })
                }
            }
        }
    }

    // update kid
    updateKid = () => {
        let {avatar,saveClick,kidData} = this.state;
        let {onSaveChild,t} = this.props;

        if(saveClick) {
            if(!kidData.firstName) {
                this.setState({message:t('booking.dialog.validation.fName'),open:true})
            }
            else if(!kidData.lastName) {
                this.setState({message:t('booking.dialog.validation.lName'),open:true})
            }
            else if(!kidData.birthdate) {
                this.setState({message:t('booking.dialog.validation.birthdate'),open:true})
            }
            else if(!kidData.gender) {
                this.setState({message:t('booking.dialog.validation.gender'),open:true})
            }
            else{
                this.setState({saveClick:false,loading:true});
                kidData.birthdate = Math.floor(new Date(kidData.birthdate).getTime() / 1000);
                if(avatar) {
                    let randomId = this.generateId(); // generate random name for avatar to avoid overwrite
                    let storageRef = firebase.storage().ref().child(`Avatars/${randomId}`)
                    storageRef.put(avatar)
                    .then((url) =>{
                        url.ref.getDownloadURL()
                        .then((res) =>{ 
                            kidData.avatar = res
                            db.ref(`Kids/${kidData.id}`).update(kidData)
                            .then(()=> {
                                this.setState({loading:false},()=> {
                                    this.handleClose2();
                                    onSaveChild();
                                })
                            }).
                            catch(e => {
                                this.setState({message:e.message,open:true,loading:false})     
                                console.log('e',e)
                            })
                        }).catch(e => {
                            this.setState({message:e.message,open:true,loading:false})     
                            console.log('e',e)
                        })
                    })
                    .catch(e => {
                        this.setState({message:e.message,open:true,loading:false})
                        console.log('e',e)
                    })
                }
                else{
                    db.ref(`Kids/${kidData.id}`).update(kidData)
                    .then(()=> {
                        setTimeout(()=> this.setState({loading:false},()=> {
                            this.handleClose2();
                            onSaveChild();
                        }),1500);
                    }).
                    catch(e => {
                        this.setState({message:e.message,open:true,loading:false})     
                        console.log('e',e)
                    })
                }
            }
        }
    }

    handleClose = () => {
        this.props.onClose();
        this.resetState();
    }

    handleClose2 = () => {
        this._isMounted = true;
        this.props.onClose();
        if(this._isMounted) this.setState({avatar:'',avatarUrl:''})
    }

    // avatar input event
    handleOpenFile = () => {
        this.fileUploader.current.click();
    }

    // select avatar event
    uploadFile = e  => { 
        this._isMounted = true;  
        if (e.target.files && e.target.files.length > 0) {
            let imageFile = e.target.files[0];
            let avatarUrl = URL.createObjectURL(imageFile)
            if(this._isMounted) this.setState({avatar:imageFile,avatarUrl});
        }
    }

    // input onChange event
    onChangeHandle = (fieldName,value) => {
        const { isEdit, kidData } = this.state;
        if(isEdit) {
            kidData[fieldName] = value;
            this.setState({kidData:kidData})
        }
        else{
            this.setState({[fieldName]:value})
        }
    }

    onChangeGender = e => {
        const { isEdit, kidData } = this.state;
        let fieldName= e.target.id;
        var value = e.target.value;
        if(isEdit) {
            kidData[fieldName] = value;
            this.setState({kidData:kidData})
        }
        else{
            this.setState({[fieldName]:value})
        }
    }
    
    render() {
        let { parentId, classes, dispatch,tReady,onSaveChild, kidId,t,isRTL, ...other } = this.props;
        let {message,open,loading,avatar,avatarUrl,firstName,lastName,birthdate,gender, isEdit,kidData} = this.state;
        const ar = "'Cairo', sans-serif";
        const en = "'Poppins', sans-serif";
        const fontFamily = isRTL === 'ar' ? ar : en;
        const genders = [{label:t('acti-comp.gender-option.boy'),value:'Boy'},{label:t('acti-comp.gender-option.girl'),value:'Girl'}];
    return (
        (<React.Fragment>
            <Dialog
              {...other}
              onClose={isEdit ? this.handleClose2 : this.handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              fullWidth={true}
              dir={isRTL === 'ar' ? 'rtl' : 'ltr'}
              style={{fontFamily}}
              maxWidth='sm'
            >
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={childDialogTheme}>
                        <DialogTitle id="alert-dialog-title" classes={{root:classes.dialogRoot}} style={{fontFamily}}>{isEdit ? t('booking.dialog.edit-child') : t('booking.dialog.add-nchild')}</DialogTitle>
                </ThemeProvider>
            </StyledEngineProvider>
            <DialogContent classes={{root:classes.contentRoot}} style={{fontFamily}}>
                <React.Fragment>
                    {/* avatar section */}
                    <input type="file" id="file" ref={this.fileUploader} onClick={(event)=> { event.target.value = null}}
                        style={{display: "none"}} accept="image/*" onChange={this.uploadFile}
                    />
                    <div className={classes.photoDiv} onClick={this.handleOpenFile}>
                        {avatar && avatarUrl ? 
                            <img src={avatarUrl} alt='logo'/>
                        :
                        isEdit && (kidData.avatar || avatarUrl) ?
                            <img src={isEdit && !avatarUrl ? kidData.avatar : avatarUrl} alt='logo'/>
                        :
                        <span style={{fontFamily}}>{t('booking.dialog.profile')}</span>
                        }
                        <AddCircle size='large' className={classes.photoIcon} />
                    </div>

                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'space-between'}}>
                        <div className={classes.inputDiv}>
                            <span className={classes.labelSpan} style={{fontFamily}}>{t('profile-comp.first')}</span>
                            <Input {...{className:classes.input,type:'text',value:isEdit ? kidData.firstName : firstName,id:'firstName',onChange:this.onChangeHandle,font:fontFamily,placeholder:t('profile-comp.first')}}/>
                        </div>
                        <div className={classes.inputDiv}>
                            <span className={classes.labelSpan} style={{fontFamily}}>{t('profile-comp.last')}</span>
                            <Input {...{className:classes.input,type:'text',value:isEdit ? kidData.lastName : lastName,id:'lastName',onChange:this.onChangeHandle,font:fontFamily,placeholder:t('profile-comp.last')}}/>
                        </div>
                    </div>

                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'space-between'}}>
                        <div className={classes.inputDiv}>
                            <span className={classes.labelSpan} style={{fontFamily}}>{t('reservation.birth-date')}</span>
                            <Input {...{className:classes.input,type:'date',value:isEdit ? kidData.birthdate : birthdate,id:'birthdate',onChange:this.onChangeHandle,font:fontFamily,placeholder:t('reservation.birth-date')}}/>
                        </div>
                        <div className={classes.inputDiv}>
                            <span className={classes.labelSpan} style={{fontFamily}}>{t('school_setting.gender')}</span>
                            <select className={`${classes.input}`} 
                            style={{fontFamily}}
                            value={isEdit ? kidData.gender : gender} id='gender' onChange={this.onChangeGender}>
                                <option value=''>{t('booking.dialog.sel-gender')}</option>
                                {genders.length > 0 && genders.map(v=> <option style={{textTransform:'capitalize'}} key={v.value} value={v.value}>{v.label}</option>)}
                            </select>
                        </div>
                    </div>
                </React.Fragment>
            </DialogContent>
            <DialogActions classes={{spacing:classes.disableSpacing}}>
                {isEdit ?
                    <div className={`${classes.saveBtn} ${classes.cancelBtn} ${isRTL === 'ar' ? classes.marLeft : ''}`} style={{fontFamily}} onClick={this.handleClose2}>
                        {t('upgrade-dialog.can')}
                    </div>
                : undefined}
                <div className={classes.saveBtn} style={{opacity:loading ? 0.4 : 1,fontFamily}} onClick={isEdit ? this.updateKid : this.addNewKid}>
                    {isEdit ? t('accept-dialog.update') : t('comp-comp.save')}
                    {loading && <ColorCircularProgress />}
                </div>

            </DialogActions>
                <Snackbar
                    anchorOrigin={{ vertical:'bottom', horizontal:'center' }}
                    key='top center'
                    open={open}
                    autoHideDuration={3000}
                    onClose={()=>this.setState({open:false})}
                    ContentProps={{
                    'aria-describedby': 'message-id',
                    }}
                    message={<span id="message-id" style={{fontFamily}}>{message}</span>}
                />
            </Dialog>
            <Backdrop className={classes.backdrop} open={loading}>
                <ColorCircularProgress />
            </Backdrop>
        </React.Fragment>)
    );}
}

export default withStyles(styles)(ChildDialog);